var RecipientSelectComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-select.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-select.component.scss?ngResource";
import { ChangeDetectorRef, Component, forwardRef, Input } from "@angular/core";
import { RecipientSelectConstants } from "./recipient-select.constants";
import { FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from "@angular/forms";
import { SubscriberComponent } from "../../subscriber/subscriber.component";
import { RecipientService } from "../shared/shared-services/recipient.service";
import { AppControllerService } from "../../../../app-controller.service";
import { DefaultRequiredFields } from "../../../models/application/generic/recipient.model";
import { SharedConstants } from "../../../constants/shared.constants";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import RecipientUtils from "../../../utils/recipient-utils";
import { phoneNumberValidator } from "../../../classes/phone-number-validator";
import { UserInformationService } from "../../../services/user/user-information.service";
import { AlertType } from "../../../../shared/models/alert";
export let RecipientSelectComponent = class RecipientSelectComponent extends SubscriberComponent {
    static { RecipientSelectComponent_1 = this; }
    recipientService;
    appControllerService;
    userInformationService;
    changeDetectorRef;
    overrideGroup = false;
    stepMetaRecipientGroups = [];
    isGroupsComingFromMetadata = true;
    showGroupsDropdown = true;
    disableEditing = false;
    showAllFormFields = true;
    disableFilter = true;
    jobId;
    formName;
    configurableLabel;
    showSACAPOptions = false;
    showRecipientGroupsDropdown = true;
    groupsOptions = [];
    hideFilter = false;
    hideAddButton = false;
    recipientForm;
    Validator = Validators;
    recipientFormLabelHeading = "Recipient details";
    provinceOptions = SharedConstants.PROVINCE;
    countryOptions = SharedConstants.COUNTRIES;
    selectOptionText = SharedConstants.DEFAULT_COUNTRY;
    sameAsResidentialChecked = false;
    // moduleId;
    groupsFromMetadata;
    onChangeSubscription;
    defaultRequiredFields = DefaultRequiredFields;
    // Form Labels
    nameLabel = RecipientSelectConstants.nameLabel;
    surnameLabel = RecipientSelectConstants.surnameLabel;
    homePhoneTelephoneLabel = RecipientSelectConstants.homeTelePhoneLabel;
    workTelephoneLabel = RecipientSelectConstants.workTelephoneLabel;
    cellphoneLabel = RecipientSelectConstants.cellphoneLabel;
    defaultCommunicationMethodLabel = RecipientSelectConstants.defaultCommunicationMethodLabel;
    emailRadioButtonLabel = RecipientSelectConstants.emailRadioButtonLabel;
    smsRadioButtonLabel = RecipientSelectConstants.smsRadioButtonLabel;
    emailLabel = RecipientSelectConstants.emailLabel;
    organisationLabel = RecipientSelectConstants.organisationLabel;
    clientVatNumberLabel = RecipientSelectConstants.clientVatNumberLabel;
    designationLabel = RecipientSelectConstants.designationLabel;
    professionalBodyHeader = RecipientSelectConstants.professionalBodyHeader;
    professionalBodyLabel = RecipientSelectConstants.professionalBodyLabel;
    professionalBodyRegNoLabel = RecipientSelectConstants.professionalBodyRegNoLabel;
    streetAddressHeader = RecipientSelectConstants.streetAddressHeader;
    streetAddressLabel = RecipientSelectConstants.streetAddressLabel;
    streetSuburbLabel = RecipientSelectConstants.streetSuburbLabel;
    streetCityLabel = RecipientSelectConstants.streetCityLabel;
    streetProvinceLabel = RecipientSelectConstants.streetProvinceLabel;
    streetCountryLabel = RecipientSelectConstants.streetCountryLabel;
    streetCodeLabel = RecipientSelectConstants.streetCodeLabel;
    postalDetailsHeader = RecipientSelectConstants.postalDetailsHeader;
    postalAddressLabel = RecipientSelectConstants.postalAddressLabel;
    postalSuburbLabel = RecipientSelectConstants.postalSuburbLabel;
    postalCityLabel = RecipientSelectConstants.postalCityLabel;
    postalProvinceLabel = RecipientSelectConstants.postalProvinceLabel;
    postalCountryLabel = RecipientSelectConstants.postalCountryLabel;
    postalCodeLabel = RecipientSelectConstants.postalCodeLabel;
    sameAsStreetAddressLabel = RecipientSelectConstants.sameAsStreetAddressLabel;
    groupsHeader = RecipientSelectConstants.groups;
    groupsLabel = RecipientSelectConstants.groupsLabel;
    componentName = RecipientSelectConstants.defaultComponentName;
    validationMessage = RecipientSelectConstants.validationMessage;
    SACAPRegistrationLabel = RecipientSelectConstants.sacapRegistrationHeader;
    sacapRegistrationNumberLabel = RecipientSelectConstants.sacapRegistrationLabel;
    sacapVerificationLabel = RecipientSelectConstants.sacapVerificationButtonLabel;
    // Form Controls
    idFormControlName = RecipientSelectConstants.idFormControlName;
    jobIdFormControlName = RecipientSelectConstants.jobIdFormControlName;
    moduleIdFormControlName = RecipientSelectConstants.moduleIdFormControlName;
    nameFormControlName = RecipientSelectConstants.nameFormControl;
    surnameFormControlName = RecipientSelectConstants.surnameFormControl;
    homePhoneFormControlName = RecipientSelectConstants.homeTelePhoneFormControl;
    workTelephoneFormControlName = RecipientSelectConstants.workTelephoneFormControl;
    cellphoneFormControlName = RecipientSelectConstants.cellphoneFormControlName;
    defaultCommunicationMethodFormControlName = RecipientSelectConstants.defaultCommunicationMethodFormControlName;
    emailFormControlName = RecipientSelectConstants.emailFormControlName;
    organisationFormControlName = RecipientSelectConstants.organisationFormControlName;
    clientVatNumberFormControlName = RecipientSelectConstants.clientVatNumberFormControlName;
    designationFormControlName = RecipientSelectConstants.designationFormControlName;
    professionalBodyFormControlName = RecipientSelectConstants.professionalBodyFormControlName;
    professionalBodyRegNoFormControlName = RecipientSelectConstants.professionalBodyRegNoFormControlName;
    streetAddressFormControlName = RecipientSelectConstants.streetAddressFormControlName;
    streetSuburbFormControlName = RecipientSelectConstants.streetSuburbFormControlName;
    streetCityFormControlName = RecipientSelectConstants.streetCityFormControlName;
    streetProvinceFormControlName = RecipientSelectConstants.streetProvinceFormControlName;
    streetCountryFormControlName = RecipientSelectConstants.streetCountryFormControlName;
    streetCodeFormControlName = RecipientSelectConstants.streetCodeFormControlName;
    postalAddressFormControlName = RecipientSelectConstants.postalAddressFormControlName;
    postalSuburbFormControlName = RecipientSelectConstants.postalSuburbFormControlName;
    postalCityFormControlName = RecipientSelectConstants.postalCityFormControlName;
    postalProvinceFormControlName = RecipientSelectConstants.postalProvinceFormControlName;
    postalCountryFormControlName = RecipientSelectConstants.postalCountryFormControlName;
    postalCodeFormControlName = RecipientSelectConstants.postalCodeFormControlName;
    groupsFormControlName = RecipientSelectConstants.groupsFormControlName;
    groupsStringArrayFormControlName = RecipientSelectConstants.groupsStringArrayFormControlName;
    sacapRegistrationNumberFormControlName = RecipientSelectConstants.sacapRegistrationNumberFormControl;
    sacapRegistrationVerifiedFormControlName = RecipientSelectConstants.sacapRegistrationNumberVerifiedFormControl;
    selectOptionTextOption = RecipientSelectConstants.PLEASE_SELECT_AN_OPTION;
    maximunLengthForThentyWord = 20;
    maximunLengthForFiftyWord = 50;
    maximunLengthForHundredWord = 100;
    maximunLengthForTwoFiftyWord = 250;
    maximunLengthFiveHundredWord = 500;
    showDefaultCommunicationMethods = true;
    requiredFieldsPlaceHolder = RecipientSelectConstants.requireFieldKey;
    constructor(recipientService, appControllerService, userInformationService, changeDetectorRef) {
        super();
        this.recipientService = recipientService;
        this.appControllerService = appControllerService;
        this.userInformationService = userInformationService;
        this.changeDetectorRef = changeDetectorRef;
        // this.moduleId = this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null;
        this.initialiseForm();
    }
    get value() {
        return this.recipientForm.value;
    }
    set value(recipient) {
        if (recipient) {
            // set recipient data from the parent component.
            this.recipientForm.get(this.idFormControlName)?.patchValue(recipient.id ? recipient.id : null);
            this.recipientForm.get(this.jobIdFormControlName)?.patchValue(recipient.jobId ? recipient.jobId : null);
            this.recipientForm.get(this.moduleIdFormControlName)?.patchValue(recipient.moduleId ? recipient.moduleId : null);
            this.recipientForm.get(this.nameFormControlName)?.patchValue(recipient.name ? recipient.name : null);
            this.recipientForm.get(this.surnameFormControlName)?.patchValue(recipient.surname ? recipient.surname : null);
            this.recipientForm.get(this.homePhoneFormControlName)?.patchValue(recipient.homePhone ? recipient.homePhone : null);
            this.recipientForm.get(this.workTelephoneFormControlName)?.patchValue(recipient.telephone ? recipient.telephone : null);
            this.recipientForm.get(this.cellphoneFormControlName)?.patchValue(recipient.cellphone ? recipient.cellphone : null);
            this.recipientForm.get(this.emailFormControlName)?.patchValue(recipient.email ? recipient.email : null);
            this.recipientForm.get(this.defaultCommunicationMethodFormControlName)?.patchValue(recipient.defaultCommunicationMethod ? recipient.defaultCommunicationMethod : null);
            this.recipientForm.get(this.organisationFormControlName)?.patchValue(recipient.organisation ? recipient.organisation : null);
            this.recipientForm.get(this.clientVatNumberFormControlName)?.patchValue(recipient.clientVatNumber ? recipient.clientVatNumber : null);
            this.recipientForm.get(this.designationFormControlName)?.patchValue(recipient.designation ? recipient.designation : null);
            this.recipientForm.get(this.professionalBodyFormControlName)?.patchValue(recipient.professionalBody ? recipient.professionalBody : null);
            this.recipientForm.get(this.professionalBodyRegNoFormControlName)?.patchValue(recipient.professionalBodyRegNum ? recipient.professionalBodyRegNum : null);
            this.recipientForm.get(this.streetAddressFormControlName)?.patchValue(recipient.streetAddress ? recipient.streetAddress : null);
            this.recipientForm.get(this.streetSuburbFormControlName)?.patchValue(recipient.streetSuburb ? recipient.streetSuburb : null);
            this.recipientForm.get(this.streetCityFormControlName)?.patchValue(recipient.streetCity ? recipient.streetCity : null);
            this.recipientForm.get(this.streetProvinceFormControlName)?.patchValue(recipient.streetProvince ? recipient.streetProvince : null);
            this.recipientForm.get(this.streetCountryFormControlName)?.patchValue(recipient.streetCountry ? recipient.streetCountry : null);
            this.recipientForm.get(this.streetCodeFormControlName)?.patchValue(recipient.streetCode ? recipient.streetCode : null);
            this.recipientForm.get(this.postalAddressFormControlName)?.patchValue(recipient.postalAddress ? recipient.postalAddress : null);
            this.recipientForm.get(this.postalSuburbFormControlName)?.patchValue(recipient.postalSuburb ? recipient.postalSuburb : null);
            this.recipientForm.get(this.postalCityFormControlName)?.patchValue(recipient.postalCity ? recipient.postalCity : null);
            this.recipientForm.get(this.postalProvinceFormControlName)?.patchValue(recipient.postalProvince ? recipient.postalProvince : null);
            this.recipientForm.get(this.postalCountryFormControlName)?.patchValue(recipient.postalCountry ? recipient.postalCountry : null);
            this.recipientForm.get(this.postalCodeFormControlName)?.patchValue(recipient.postalCode ? recipient.postalCode : null);
            if (recipient.hasOwnProperty(this.groupsStringArrayFormControlName) && recipient.groupsStringArray.length > 0) {
                recipient.groups = this.setRecipientGroupsFromTheGroupsStringArray(recipient.groupsStringArray);
                this.recipientForm.get(this.groupsFormControlName).patchValue(recipient.groups);
            }
        }
        this.checkIfPostalDetailsIsTheSameAsResidentialDetails(recipient);
        this.onChange(recipient);
        this.onTouched();
    }
    ngOnChanges(changes) {
        if (changes && changes.hasOwnProperty("stepMetaRecipientGroups") && changes.stepMetaRecipientGroups.currentValue && changes.stepMetaRecipientGroups.currentValue.length > 0) {
            this.configureComponentOnInit();
        }
    }
    checkSACAPOptions() {
        if (this.showSACAPOptions) {
            // add sacap controls
            this.recipientForm.addControl(this.sacapRegistrationNumberFormControlName, new FormControl(null, Validators.required));
            this.recipientForm.addControl(this.sacapRegistrationVerifiedFormControlName, new FormControl(null, Validators.required));
            this.recipientForm.updateValueAndValidity();
        }
    }
    onChange = () => {
    };
    onTouched = () => {
    };
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    setDisabledState(disabled) {
        if (disabled) {
            this.recipientForm.disable();
            this.disableEditing = true;
            this.recipientForm.get(this.postalProvinceFormControlName).disable();
            this.recipientForm.get(this.postalCountryFormControlName).disable();
        }
        else {
            this.recipientForm.enable();
            this.disableEditing = false;
            this.recipientForm.get(this.postalProvinceFormControlName).enable();
            this.recipientForm.get(this.postalCountryFormControlName).enable();
        }
    }
    writeValue(recipient) {
        if (recipient === null) {
            this.resetFormControls();
            return;
        }
        if (recipient) {
            this.value = recipient;
        }
    }
    // communicate the inner form validation-tab to the parent form
    validate(_) {
        return this.recipientForm.valid ? null : { formName: { valid: false } };
    }
    ngOnInit() {
        this.subscribeToFormChanges();
        this.configureComponentOnInit();
        this.subscribeToClearForm();
        this.checkOrganisationSettings();
    }
    ngOnDestroy() {
        this.onChangeSubscription.unsubscribe();
    }
    onResidentialInputEntered($event, formControlName) {
        if (this.sameAsResidentialChecked) {
            const inputValue = $event.target.value;
            const postalFormControl = this.recipientForm.get(formControlName);
            postalFormControl.patchValue(inputValue);
        }
    }
    onSameAsResidentialChecked($event) {
        const checkBoxStatus = $event.target.checked;
        if (checkBoxStatus) {
            this.sameAsResidentialChecked = true; // checks the checkbox and disables fields
            RecipientUtils.copyStreetDetailsDataToPostalDetailsFields(this.recipientForm, true);
            RecipientUtils.clearPostalDetailsValidators(this.recipientForm, true);
        }
        else {
            this.sameAsResidentialChecked = false;
            RecipientUtils.enablePostalDetails(this.recipientForm);
            RecipientUtils.restorePostalDetailsValidators(this.recipientForm, this.stepMetaRecipientGroups);
            this.recipientForm.updateValueAndValidity();
            this.changeDetectorRef.detectChanges();
        }
    }
    enablePostalSelects(postalProvinceFormControlName) {
        if (this.sameAsResidentialChecked) {
            this.recipientForm.get(postalProvinceFormControlName).enable();
        }
    }
    disablePostalSelects(postalProvinceFormControlName) {
        if (this.sameAsResidentialChecked) {
            this.recipientForm.get(postalProvinceFormControlName).disable();
        }
    }
    markControlAsTouched(controlName) {
        if (controlName) {
            this.recipientForm.get(controlName).markAllAsTouched();
            this.recipientForm.get(controlName).updateValueAndValidity();
        }
    }
    loadRecipient(recipient) {
        if (recipient) {
            if (!this.disableEditing && this.showAllFormFields) {
                // enable postal formControls when loading recipient from the filter
                this.sameAsResidentialChecked = false; // reset sameAsResidential checkbox
                RecipientUtils.enablePostalDetails(this.recipientForm);
                RecipientUtils.restorePostalDetailsValidators(this.recipientForm, this.stepMetaRecipientGroups);
            }
            this.value = recipient;
        }
    }
    updateModel() {
        if (this.stepMetaRecipientGroups.length > 0) {
            const currentGroupStringArray = this.recipientForm.get(this.groupsStringArrayFormControlName).value;
            const groups = currentGroupStringArray.map((groupStringValue) => {
                return {
                    groupName: groupStringValue, groupType: this.stepMetaRecipientGroups[0].groupType
                };
            });
            this.recipientForm.get(this.groupsFormControlName).patchValue(groups);
        }
    }
    onRadioButtonChanged(selectedMethodOfCommunication) {
        const preferredMethodOfCommunication = selectedMethodOfCommunication.trim().toLowerCase();
        const emailFormControl = this.recipientForm.get(this.emailFormControlName);
        const cellphoneFormControl = this.recipientForm.get(this.cellphoneFormControlName);
        const recipientGroup = this.stepMetaRecipientGroups[0];
        const isCellPhoneRequiredFromMetaData = this.isCellphoneFormFieldRequiredInTheMetadata(recipientGroup);
        const isEmailRequiredFromMetadata = this.isEmailFormFieldRequiredInTheMetadata(recipientGroup);
        if (preferredMethodOfCommunication.toLowerCase().trim() === "email") {
            this.setEmailFormFieldAsRequired(emailFormControl);
            if (isCellPhoneRequiredFromMetaData) {
                this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            }
            else {
                this.clearCellphoneFormFieldRequiredValidation(cellphoneFormControl);
            }
        }
        if (preferredMethodOfCommunication.toLowerCase().trim() === "sms") {
            this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            if (isEmailRequiredFromMetadata) {
                this.setEmailFormFieldAsRequired(emailFormControl);
            }
            else {
                this.clearEmailFormFieldRequiredValidation(emailFormControl);
            }
        }
    }
    getOrganisationSettings() {
        const organisationId = Number(this.appControllerService.selectedOrganisationId);
        const organisationInformation = this.userInformationService.getOrganisationInformation(organisationId);
        if (organisationInformation?.settings) {
            return organisationInformation.settings;
        }
        else {
            return null;
        }
    }
    setRecipientGroupsFromTheGroupsStringArray(groupsStringArray) {
        // builds group object from the metadata and the groupStringArray
        const recipientGroups = [];
        groupsStringArray.forEach((groupNameFromStringArray) => {
            for (const groupFromMetadata of this.stepMetaRecipientGroups) {
                if (groupFromMetadata.groupName.toLowerCase().trim() === groupNameFromStringArray.toLowerCase().trim()) {
                    recipientGroups.push({ groupName: groupNameFromStringArray, groupType: groupFromMetadata.groupType });
                }
            }
        });
        return recipientGroups;
    }
    initialiseForm() {
        // initialise formControls
        this.recipientForm = new FormGroup({
            id: new FormControl(),
            sacapRegistrationNumber: new FormControl(0),
            jobId: new FormControl(this.jobId ? +this.jobId : null),
            moduleId: new FormControl(this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null),
            name: new FormControl(),
            surname: new FormControl(),
            homePhone: new FormControl(null, phoneNumberValidator),
            telephone: new FormControl(null, phoneNumberValidator),
            cellphone: new FormControl(null, phoneNumberValidator),
            defaultCommunicationMethod: new FormControl(this.emailRadioButtonLabel),
            email: new FormControl(null, Validators.email),
            organisation: new FormControl(),
            clientVatNumber: new FormControl(),
            designation: new FormControl(),
            professionalBody: new FormControl(),
            professionalBodyRegNum: new FormControl(),
            streetAddress: new FormControl(),
            streetSuburb: new FormControl(),
            streetCity: new FormControl(),
            streetProvince: new FormControl(),
            streetCountry: new FormControl(SharedConstants.DEFAULT_COUNTRY),
            streetCode: new FormControl(),
            postalAddress: new FormControl(),
            postalSuburb: new FormControl(),
            postalCity: new FormControl(),
            postalProvince: new FormControl(),
            postalCountry: new FormControl(SharedConstants.DEFAULT_COUNTRY),
            postalCode: new FormControl(),
            groupsStringArray: new FormControl([]),
            groups: new FormControl(null)
        });
    }
    subscribeToFormChanges() {
        // any time the inner form changes update the parent of any change
        this.onChangeSubscription = this.recipientForm.valueChanges.subscribe(recipient => {
            this.onChange(recipient);
            this.onTouched();
        });
    }
    populateGroupsDropdown() {
        // Populates the groups dropdown
        if (this.isGroupsComingFromMetadata) {
            if (this.stepMetaRecipientGroups.length === 0) {
                this.stepMetaPropertyNotSetErrMessage("stepMetaRecipientGroups");
                return;
            }
            this.stepMetaRecipientGroups = RecipientUtils.standardizeRecipientGroupsObject(this.stepMetaRecipientGroups);
            this.groupsOptions = this.stepMetaRecipientGroups.map((group => {
                return group.groupName;
            }));
        }
        else {
            // if groups are not coming from the metadata fetch them from the lookups
            this.getRecipientGroupsFromLookups();
        }
    }
    getRecipientGroupsFromLookups() {
        // Fetch groups from the recipientGroups lookup
        this.cleanupAfterDestroy(this.recipientService.getRecipientGroupsLookupObservable(this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null)).subscribe({
            next: (groupsLookups) => {
                if (groupsLookups && groupsLookups.length > 0) {
                    this.populateRecipientGroups(groupsLookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    populateRecipientGroups(groupsLookups) {
        // populates the dropdown with groups from the lookups
        groupsLookups.forEach(groupLookup => {
            const lookup = JSON.parse(groupLookup.content);
            this.groupsOptions.push(lookup.value);
        });
        this.groupsOptions.sort((a, b) => a?.localeCompare(b));
        this.changeDetectorRef.markForCheck();
    }
    stepMetaPropertyNotSetErrMessage(propertyName) {
        // throws warning when one of the properties of the metadata is not set
        // this.appControllerService.showMessage(`The ${propertyName} ${this.metadataPropertyNotSetErrMsg}`, AlertType.Warning);
    }
    checkIfPostalDetailsIsTheSameAsResidentialDetails(recipient) {
        const postalDetailsMatchResidentialDetails = RecipientUtils.checkAddressDetails(recipient, this.recipientForm);
        if (postalDetailsMatchResidentialDetails) {
            RecipientUtils.disablePostalDetails(this.recipientForm);
            this.sameAsResidentialChecked = true;
            this.changeDetectorRef.detectChanges();
        }
    }
    configureComponentOnInit() {
        // configures the component when it is initialized
        this.populateGroupsDropdown();
        this.setRequiredFields();
        this.setGroupsFromMetadata();
        this.setDisableEditing();
        this.setConfigurableLabel();
        this.setJobId();
        this.showOrHideGroupsDropdown();
        this.changeDetectorRef.detectChanges();
    }
    setRequiredFields() {
        if (this.stepMetaRecipientGroups.length > 0) {
            if (this.stepMetaRecipientGroups[0].hasOwnProperty("requiredFields") && Object.keys(this.stepMetaRecipientGroups[0].requiredFields)?.length > 0) {
                this.loadRequiredFields(this.stepMetaRecipientGroups[0].requiredFields);
            }
            else {
                this.stepMetaRecipientGroups[0].requiredFields = this.defaultRequiredFields;
                this.loadRequiredFields(this.stepMetaRecipientGroups[0].requiredFields);
            }
        }
    }
    setGroupsFromMetadata() {
        // sets the recipient groups from the metadata and hides the group dropdown if only 1 group is available from metadata
        if (this.stepMetaRecipientGroups.length === 1) {
            const groups = this.stepMetaRecipientGroups.map(((group) => {
                return {
                    groupName: group.groupName, groupType: group.groupType
                };
            }));
            if (this.isGroupsComingFromMetadata && this.recipientForm) {
                this.recipientForm.get(this.groupsStringArrayFormControlName).setValue([groups[0].groupName]);
                this.recipientForm.get(this.groupsFormControlName).setValue([groups[0]]);
                this.showRecipientGroupsDropdown = false;
            }
        }
    }
    showOrHideGroupsDropdown() {
        // shows or hides the recipient groups dropdown
        if (this.showGroupsDropdown) {
            this.showRecipientGroupsDropdown = true;
        }
        else {
            this.showRecipientGroupsDropdown = false;
        }
    }
    setDisableEditing() {
        if (this.disableEditing) {
            this.setDisabledState(this.disableEditing);
        }
    }
    setConfigurableLabel() {
        this.recipientFormLabelHeading = this.configurableLabel ? `${this.configurableLabel} details` : `Personal details`;
        if (this.recipientFormLabelHeading === null || this.recipientFormLabelHeading === undefined) {
            this.stepMetaPropertyNotSetErrMessage("label");
        }
    }
    subscribeToClearForm() {
        this.cleanupAfterDestroy(this.recipientService.listenToClearRecipient()).subscribe(isCleaned => {
            if (!isCleaned)
                return;
            this.value = null;
            this.recipientForm.reset();
        });
    }
    resetFormControls() {
        this.sameAsResidentialChecked = false;
        RecipientUtils.enablePostalDetails(this.recipientForm);
        this.recipientForm.reset();
        this.recipientForm.get(this.streetCountryFormControlName)?.patchValue(SharedConstants.DEFAULT_COUNTRY);
        this.recipientForm.get(this.postalCountryFormControlName)?.patchValue(SharedConstants.DEFAULT_COUNTRY);
        this.recipientForm.get(this.moduleIdFormControlName).patchValue(this.appControllerService.selectedModuleID ? Number(this.appControllerService.selectedModuleID) : null);
        this.configureComponentOnInit();
    }
    setJobId() {
        if (this.jobId && +this.jobId >= 0) {
            this.recipientForm.get(this.jobIdFormControlName).patchValue(+this.jobId);
        }
    }
    loadRequiredFields(requiredFields) {
        for (const [fieldName, isRequired] of Object.entries(requiredFields)) {
            if (isRequired) {
                RecipientUtils.checkRequiredFields(this.stepMetaRecipientGroups, this.recipientForm);
            }
        }
    }
    isCellphoneFormFieldRequiredInTheMetadata(recipientGroup) {
        let isCellphoneRequired = false;
        if (this.stepMetaRecipientGroups.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Cellphone", "cellphone")) {
            isCellphoneRequired = true;
        }
        return isCellphoneRequired;
    }
    isEmailFormFieldRequiredInTheMetadata(recipientGroup) {
        let isEsmailRequired = false;
        if (this.stepMetaRecipientGroups.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Email", "email")) {
            isEsmailRequired = true;
        }
        return isEsmailRequired;
    }
    setEmailFormFieldAsRequired(emailFormControl) {
        emailFormControl.setValidators([Validators.required, Validators.email]);
        emailFormControl.updateValueAndValidity();
    }
    setCellphoneFormFieldAsRequired(cellphoneFormControl) {
        cellphoneFormControl.setValidators([Validators.required, phoneNumberValidator]);
        cellphoneFormControl.updateValueAndValidity();
    }
    clearCellphoneFormFieldRequiredValidation(cellphoneFormControl) {
        cellphoneFormControl.clearValidators();
        cellphoneFormControl.addValidators(phoneNumberValidator);
    }
    clearEmailFormFieldRequiredValidation(emailFormControl) {
        emailFormControl.clearValidators();
        emailFormControl.addValidators(Validators.email);
    }
    getPropertyThatMatchesDataCase(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    setDefaultCommunicationSettings(organisationSettings) {
        this.showDefaultCommunicationMethods = false;
        const isSMSEnabledFromOrganisationSettings = organisationSettings.enableSms;
        const hasSMSProvider = (!(organisationSettings.smsProvider === "" || organisationSettings.smsProvider === "null" || organisationSettings.smsProvider === null));
        if (isSMSEnabledFromOrganisationSettings && hasSMSProvider) {
            this.showDefaultCommunicationMethods = true;
        }
        else {
            this.disableCommunicationMethods();
        }
        this.changeDetectorRef.detectChanges();
    }
    checkOrganisationSettings() {
        const organisationSettings = this.getOrganisationSettings();
        if (organisationSettings) {
            this.setDefaultCommunicationSettings(organisationSettings);
        }
        else {
            this.disableCommunicationMethods();
        }
    }
    disableCommunicationMethods() {
        this.showDefaultCommunicationMethods = false;
    }
    onVerifySacapDetails() {
        const constituentId = this.recipientForm.get(this.sacapRegistrationNumberFormControlName).value;
        this.cleanupAfterDestroy(this.recipientService.verifySACAPRegistration(constituentId)).subscribe({
            next: (response) => {
                this.setSACAPRecipientData(response);
                this.setSACAPRecipientVerification();
                this.appControllerService.showMessage("membership validated", AlertType.Success);
            },
            error: (error) => {
                this.clearSACAPRecipientVerification();
                switch (error.status) {
                    case 404: {
                        this.appControllerService.showMessage(error.error, AlertType.Error);
                        break;
                    }
                    case 403: {
                        this.appControllerService.showMessage(error.error, AlertType.Error);
                        break;
                    }
                    default: {
                        this.appControllerService.handleServerErrorMessage("Recipient verification", error, CRUDOperation.Get);
                    }
                }
            }
        });
    }
    setSACAPRecipientData(memberData) {
        this.recipientForm.get(this.nameFormControlName).patchValue(memberData.firstname);
        this.recipientForm.get(this.nameFormControlName).disable();
        this.recipientForm.get(this.surnameFormControlName).patchValue(memberData.lastname);
        this.recipientForm.get(this.surnameFormControlName).disable();
        this.recipientForm.get(this.professionalBodyFormControlName).patchValue("SACAP");
        this.recipientForm.get(this.professionalBodyFormControlName).disable();
        this.recipientForm.get(this.professionalBodyRegNoFormControlName).patchValue(memberData.professionalNumber);
        this.recipientForm.get(this.professionalBodyRegNoFormControlName).disable();
        this.recipientForm.get(this.emailFormControlName).patchValue(memberData.email);
        this.recipientForm.get(this.emailFormControlName).disable();
        this.recipientForm.get(this.cellphoneFormControlName).patchValue(memberData.telephone);
        this.recipientForm.get(this.cellphoneFormControlName).disable();
    }
    ngAfterViewInit() {
        if (this.showSACAPOptions) {
            this.checkSACAPOptions();
            this.changeDetectorRef.detectChanges();
        }
    }
    setSACAPRecipientVerification() {
        this.recipientForm.get(this.sacapRegistrationVerifiedFormControlName).setValue(true);
    }
    clearSACAPRecipientVerification() {
        this.recipientForm.get(this.sacapRegistrationVerifiedFormControlName).reset();
    }
    static ctorParameters = () => [
        { type: RecipientService },
        { type: AppControllerService },
        { type: UserInformationService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        overrideGroup: [{ type: Input }],
        stepMetaRecipientGroups: [{ type: Input }],
        isGroupsComingFromMetadata: [{ type: Input }],
        showGroupsDropdown: [{ type: Input }],
        disableEditing: [{ type: Input }],
        showAllFormFields: [{ type: Input }],
        disableFilter: [{ type: Input }],
        jobId: [{ type: Input }],
        formName: [{ type: Input }],
        configurableLabel: [{ type: Input }],
        showSACAPOptions: [{ type: Input }]
    };
};
RecipientSelectComponent = RecipientSelectComponent_1 = __decorate([
    Component({
        selector: "app-recipient-select",
        template: __NG_CLI_RESOURCE__0,
        providers: [{
                provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RecipientSelectComponent_1), multi: true
            }, {
                provide: NG_VALIDATORS, useExisting: forwardRef(() => RecipientSelectComponent_1), multi: true
            }],
        styles: [__NG_CLI_RESOURCE__1]
    })
], RecipientSelectComponent);
